import {ConnectionWithReservationsDto} from '@lib/infrastructure';
import {toWorkspaceReservation} from '../../workspaceReservation/mappers';
import {WorkspaceReservationsWithWorkdays} from '../types';

export const toWorkspaceReservationsAndWorkdays = (
  data: ConnectionWithReservationsDto[],
): WorkspaceReservationsWithWorkdays => {
  return {
    workspaceReservations: data
      .flatMap((info) => info.workspaceReservations)
      .map((workspaceReservation) => toWorkspaceReservation(workspaceReservation)),
    workdays: data.flatMap((info) => info.workdays),
    originalData: data,
  };
};
